import React from "react";
import Skills from "./Skills/Skills";

const About = () => {
  return (
    <section className="py-8">
      <div className="flex flex-wrap md:px-4">
        <div className="w-full">
          <div className="md:mx-4">
            <h3 className="text-2xl text-gray-800 font-bold mb-4">SUMMARY</h3>
            <p  style={{ marginTop:'60px', fontSize:'16px', color:'#171717', fontFamily:'sans-serif', fontWeight:'500'}} className=" text-gray-400 leading-6 mb-3">
            I am Hafizur Rahman. 21 years young. I'm a student at BA (Hon's) major is English. My hobbies are Coding Programme and reading books. In my free time I try to build and strengthful my acquired skills.
            </p>
            <p style={{ marginTop:'40px', fontSize:'16px', color:'#171717', fontFamily:'sans-serif', fontWeight:'500'}} className=" text-gray-400 leading-6 mb-3">
            As a front end deveploer, finished many projects with front end and backend using react, javascript, node.js, express.js and mongdb. I am always energetic and eager to learn new skills. Adept at contributing to a highly collaborative work environment and determined to finding a solution.
            </p>
          </div>
          <Skills />
        </div>
      </div>
    </section>
  );
};

export default About;
